import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter3 extends Component {
  static displayName = Chapter3.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय–3 घर का त्याग 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                पोखवां की गलियों में एक साधारण-सा किशोर चलता था, पर उसकी आँखों में संसार नहीं — अनंत का आकाश बसता था। वह खेलता भी था, मित्रों से हँसकर बोलता भी था, पर भीतर कहीं एक मौन तपश्चर्या चलती रहती थी।
                कभी अचानक गायब हो जाता, घंटों तक गंगा किनारे बैठा रहता, और दूर आकाश की ओर देखते-देखते मानो किसी अनसुनी पुकार को सुन रहा हो।
                कोई समझ नहीं पाया — कि एक दिन यह मौन, एक महत् क्रांति में रूपांतरित होने वाला है।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌙 चिंतन में डूबा बालक, और माँ का आश्चर्य</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              बालक ब्रह्म नारायण के पिता तीर्थयात्रा, कर्मकांड और दान-पुण्य में रत रहते। घर में धार्मिक वातावरण था, पर यह बालक केवल कर्म से संतुष्ट नहीं था — वह सत्य की जड़ खोज रहा था।
              माता ने कई बार देखा — रात गहरा जाती, गाँव सो जाता, पर उनका पुत्र जाग रहा होता।
              कभी गीता खोले, कभी उपनिषद, कभी कोई साधु के शब्दों पर ध्यान लगाए बैठा।
              माता के मन में प्रश्न था — <strong>“यह बच्चा किस राह पर जा रहा है?”</strong>
              उन्हें नहीं पता था — कि वह राह पृथ्वी की नहीं — ब्रह्म की थी।
            </p>

            {/* More Sections */}
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🔥 जागरण की प्रथम चिनगारी</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक दिन गाँव में एक वृद्ध संन्यासी आए। उनकी आँखें ज्यों बुझा हुआ अग्निकुंड — पर भीतर तप की ज्वाला।
              उन्होंने बालक को देखकर कहा— “तुम्हारा मन इस घर में नहीं टिकेगा। ज्ञान तुम्हें बाहर पुकार रहा है।”
              किशोर मन हिल गया। यह वह सोच था जो वह महीनों से छिपाए बैठा था।
              उसी दिन रात, वह देर तक जागा रहा — और पहली बार उसके भीतर एक अचल संकल्प जन्मा।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌊 जगह-जगह जाना, साधुओं से मिलना</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              वह धीरे-धीरे घर से बाहर निकलने लगा। पोखवां से टिकारी, टिकारी से गया, गया से वाराणसी…
              जहाँ कहीं साधु मिलते, वह चरण स्पर्श कर, गीता, वेदांत, आत्मा, ब्रह्म पर प्रश्न पूछता।
              अधिकांश साधु चकित हो जाते— “इतनी कम उम्र, और इतना गहरा चिंतन?” पर उत्तर चाहे जो मिलता, एक प्रश्न बार-बार भीतर उठता— “मैं कौन हूँ?”
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              ✨ अंदर का तूफ़ान — अब निर्णय निकट था
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक रात गाँव शांत था, तारों से भरा आकाश, हल्की हवा में नीम की सुगंध. बालक घर की छत पर बैठा था। वह संसार को देख रहा था — और उसके भीतर एक आवाज़ उठी— “यह घर, यह संसार, यह मोह — मुझे नहीं बाँध सकते। मेरा मार्ग वेदांत है, ब्रह्म है, संन्यास है।” उस रात उसने निश्चय कर लिया — वह घर छोड़ देगा।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🌄 पहली विदाई: न कोई शोर, न कोई विद्रोह
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              सुबह होते-होते वह उठ खड़ा हुआ। न कोई रोना, न कोई भावनात्मक नाटक— क्योंकि उसका निर्णय हृदय नहीं, आत्मा ने लिया था। माता सो रही थीं। वह उनके चरणों में सिर रखकर बोला— “माँ, मुझे क्षमा करना। मेरा जीवन केवल परिवार के लिए नहीं — समस्त विश्व के लिए है।” घर के बाहर निकला, घास पर ओस की बूँदें चमक रही थीं, और पूर्व दिशा से सूरज की पहली रेखा उठ रही थी। बालक का हर कदम गृहस्थी से दूर, संन्यास की ओर था।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🕉️ गुरु की खोज — जैसे पतंगा दीप की ओर
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              वह भटकता नहीं था — मानो कोई अदृश्य हाथ उसे मार्ग दिखा रहा था। गया से काशी, काशी से प्रयाग, और फिर अनगिनत जंगल, पहाड़, आश्रम… उसके भीतर एक ही पुकार— “मुझे अपना गुरु चाहिए। शरीर का नहीं — आत्मा का मार्गदर्शक।” कई दिनों तक भटकने के बाद एक दिन उसे वह पुरुष मिले, जिन्हें देखकर उसके प्राण काँप उठे— स्वामी अद्वैतानंद सरस्वती जी। उनकी आँखों में सौम्यता, पर भीतर तप की असह्य चमक। ब्रह्म नारायण समझ गया— यही हैं मेरे गुरु।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🙏 गुरुदीक्षा</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              वह उनके चरणों में गिर पड़ा— “मुझे अपने शिष्य रूप में स्वीकार करें।” स्वामी अद्वैतानंद ने किशोर के सिर पर हाथ रखकर कहा— “बेटा, तू जन्म से ही संन्यासी है। अब केवल दुनिया को यह ज्ञात कराना है।” और वहीं, गंगा तट पर, मंत्र-दीक्षा हुई। किशोर ब्रह्म नारायण अब केवल एक बालक नहीं रहा — वह प्रारंभ हो चुका था एक ब्रह्मज्ञानी, एक परमहंस, एक भावी शंकराचार्य का मार्ग।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🌺 यह केवल त्याग नहीं—पुनर्जन्म था
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उस क्षण एक परिवार ने पुत्र खोया, पर भारत ने अपना भविष्य पाया। संन्यास का वस्त्र धारण कर वह अनंत की यात्रा पर निकल पड़ा— एकांत, साधना, मौन, ध्यान… और आगे चलकर यही बालक बना—<br/>
              ✅ पर्वतों का यात्री<br/>
              ✅ योग और वेदांत का अभ्यासक<br/>
              ✅ और अंततः जगद्गुरु शंकराचार्य, द्वारकापीठाधीश्वर परमहंस स्वामी ब्रह्मानंद सरस्वती जी महाराज।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter2" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter4" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}